var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"auth0",attrs:{"id":"auth0Lock"}})}
var staticRenderFns = []

export { render, staticRenderFns }